import { helper } from '@ember/component/helper';
import Utils from '../utils/utils';

// doesn't work well with Big.js numbers
export default helper(function roundNumber(params /*, hash*/) {
  if (params.length < 1) return 'n/a [np]';
  if (params[0] === undefined) return 'n/a [undef]';

  const number = params[0],
    decPlaces = Utils.isNumeric(params[1]) ? params[1] : 2;

  if (typeof number === 'number') {
    const roundedNumber = number.toScale(decPlaces);
    if (roundedNumber === 0) {
      return number.toScale(4);
    } else {
      return number.toScale(decPlaces);
    }
  }
  if (typeof number === 'object')
    // assume bigint
    return number.round(decPlaces);
  return 'n/a [unk]';
});
